import { render, staticRenderFns } from "./UnityManager.vue?vue&type=template&id=06533a64&"
import script from "./UnityManager.vue?vue&type=script&lang=ts&"
export * from "./UnityManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports